<template>
  <RecommendationButtonTemplate
    class="button-errors"
    @click="handleClickErrors"
  >
    <template #icon>
      <icon name="nomad:error" size="3.5rem" />
    </template>
    <span class="text">
      Teste toi sur toutes tes <strong>erreurs</strong> avec NOMAD +
    </span>
  </RecommendationButtonTemplate>
</template>
<script setup lang="ts">
import DialogListExercise from '~/components/dialog/list/exercise/DialogListExercise.vue';
import { ExerciseReplayMode } from '~/types/app';

interface Props {}

defineProps({
  
});

const dialog = useDialogStore();

const { exercisesWithErrors } = inject(INJECT_RECOMMENDATION);

const route = useRoute();

const profile = useProfileStore();

const { categoryManager } = inject(INJECT_CATEGORY_PAGE);

const { openExercisesErrors, startExerciseWithErrors } =
  useAppEventChapterRecommendation(categoryManager);

const handleClickErrors = () => {
  if (!profile.isASubscriber) return;
  const items = exercisesWithErrors.value.map(({ score, exercise }) => {
    return {
      id: exercise.id,
      label: exercise.title,
      score,
      url: `${route.path}/exercise/${exercise.slug}?mode=${ExerciseReplayMode.OnlyErrors}`,
      click: () => {
        startExerciseWithErrors(exercise.id);
        dialog.close();
      },
    };
  });
  openExercisesErrors();
  if (items.length === 1) {
    startExerciseWithErrors(items[0].id);
    return navigateTo(items[0].url);
  }
  dialog.open(DialogListExercise, {
    level: DialogLevel.Info,
    title: 'Test toi sur toutes les erreurs avec NOMAD+',
    items,
    cancel: false,
    confirm: false,
    onCancel: () => dialog.close(),
  });
};
</script>
<style lang="scss" scoped>
@use 'sass:color';

.button-errors {
  width: 100%;
}

.text {
  text-align: left;

  @include font('n', 600, 'secondary');

  strong {
    color: var(--color_error);
  }
}
</style>
